<template lang="pug">
.form(v-loading="loading")
  van-field(v-model="formData.title" label="标题" disabled)
  van-field(v-model="formData.prjName" label="项目名称" disabled)
  van-field(v-model="formData.prjCode" label="项目编号" disabled)
  van-field(v-model="formData.operUserName" label="申请人" disabled)
  van-field(v-model="formData.operTime" label="提交时间" disabled)
  van-field(v-model="formData.content" type="textarea" label="内容" disabled)
</template>

<script>
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";

export default {
  data () {
    return {
      formData: {},
      loading: false
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      floderObj: state => state.uploaderLocal.floderObj,
      enterpriseId: state => state.enterprise.enterpriseId,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo
    })
  },
  mounted () {
    this.getBusinessForm();
  },
  methods: {
    async getBusinessForm() {
      try {
        this.loading = true;
        const res = await flowService.getBusinessForm(this.routerParams.flowInstanceId);
        this.formData = res.data.object || {};
        this.loading = false;
      } catch (error) {
        this.$error(error);
      }
    }
  }
};
</script>

<style>

</style>
